// extracted by mini-css-extract-plugin
export var planCard = "_s6-0";
export var planList = "_s6-1";